<template lang="html">
  <!-- Content -->
  <d-row>
    <d-col lg="9">
      <d-card class="mb-4 card-small">
        <!-- Card Header -->
        <d-card-header class="border-bottom">
          <d-row class="align-items-center">
            <d-col cols="12" lg="6">
              <h6 class="m-0">Dados cadastrais</h6>
            </d-col>
          </d-row>
        </d-card-header>

        <d-list-group flush>
          <d-list-group-item class="p-3">
            <reseller-form ref="resellerForm"/>
            <comments/>
          </d-list-group-item>
        </d-list-group>
        <confirmation-modal
          :cancel="close"
          :confirm="deleteRow"
          title="Confirme exclusão de parceiro"
          message="Tem certeza que deseja excluir este parceiro?"/>
      </d-card>
    </d-col>
    <!-- Sidebar Widgets -->
    <d-col lg="3" md="12">
      <sidebar-actions :model="reseller" @save="save" @blockAccess="blockAccess" @printReport="printReport" />
    </d-col>
  </d-row>
</template>

<script>
import Events from '_utils/events';
import Loader from '_shared/Loader.vue';
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import ResellerForm from './ResellerForm.vue';
import ResellerActions from './ResellerActions';
import Comments from './Comments.vue';
import SidebarActions from '../components/SidebarActions.vue';
import { MODEL, _LOAD_MODEL_, _SAVE_RESELLER_SUCCESS_, _DELETE_RESELLER_ } from './ResellerModel';
import { _SET_RESELLER_ } from '../../lead/components/LeadModel';

export default {
  name: 'reseller-page',
  mixins: [ResellerActions],
  props: {
  },
  components: {
    Loader,
    Comments,
    ResellerForm,
    SidebarActions,
    ConfirmationModal,
  },
  data() {
    return {
      loading: false,
      selectReseller: null,
    };
  },
  computed: {
    reseller() {
      const { reseller } = this.$store.state.reseller;
      if (reseller) {
        Events.$emit(_LOAD_MODEL_, reseller);
        return reseller;
      }
      return MODEL;
    },
  },
  methods: {
    save() {
      this.$refs.resellerForm.save();
      Events.$on(_SAVE_RESELLER_SUCCESS_, reseller => {
        this.$router.push(`/admin/parceiros/${reseller.id}`);
      });
    },
    printReport() {
      this.$router.push({ name: 'admin-lead-list', params: { page: 1 } });
      Events.$emit(_SET_RESELLER_, this.reseller);
    },
  },
  mounted() {
    Events.$on('loading', loading => {
      this.loading = loading;
    });
    Events.$on(_DELETE_RESELLER_, reseller => {
      this.selectReseller = reseller.id;
    });
  },
};
</script>

<style lang="scss" scoped>
.control__button {
  display: flex;
  justify-content: flex-start;
}
</style>
